import { themeVars } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const modalContentClass = style({
  width: '100%',
  fontSize: themeVars.font.size.textLg,
});

export const scrollableClass = style({
  overflowY: 'auto',
  overflowX: 'hidden',
  maxHeight: '50vh',
});
